export enum PRODUCT_SORTS {
  name = "name",
  createdAt = "createdAt",
}

export enum MAIN_TAG {
  hot = "hot",
  best_seller = "best_seller",
  new = "new",
}

export const MAIN_TAG_OPTIONS = [
  // { value: MAIN_TAG.new, label: "New Dish" },
  { value: MAIN_TAG.hot, label: "Hot" },
  { value: MAIN_TAG.best_seller, label: "Best Seller" },
  {
    value: null,
    label: "Null",
  },
];

export enum SUB_TAG {
  special_on_today = "special_on_today",
  milk_tea = "milk_tea",
  juice = "juice",
  coffee = "coffee",
}

export const SUB_TAG_OPTIONS = [
  { value: SUB_TAG.special_on_today, label: "Special On Today" },
  {
    value: SUB_TAG.milk_tea,
    label: "Milk Tea",
  },
  {
    value: SUB_TAG.juice,
    label: "Juice",
  },
  {
    value: SUB_TAG.coffee,
    label: "Coffee",
  },
];

export enum PRODUCT_WARRANTY {
  INTERNATIONAL_WRRANTY = "International warranty",
}

export const PRODUCT_WARRANTY_OPTIONS = [
  { value: PRODUCT_WARRANTY.INTERNATIONAL_WRRANTY, label: "International warranty" },
];

export enum ProductStatusEnum {
  ACTIVE = 1,
  INACTIVE = 0,
  DRAFT = 2,
  BANNED = 3,
  PENDING_FOR_REVIEW = 4,
  REJECTED = 5,
}

export enum BadgeStatusEnum {
  INACTIVE = 0,
  ACTIVE = 1,
  DRAFT = 2,
}

export enum InventoryStatusEnum {
  IN_STOCK = 1,
  OUT_OF_STOCK = 0,
  RUN_OUT_SOON = 2,
}

export enum SelectDate {
  WEEK,
  MONTH,
  YEAR,
}

export const DEFAULT_PRODUCT_QUANTITY = 10000;

export enum TYPE_OF_ATTRIBUTE {
  is_required = "is_required",
  is_multiple_choice = "is_multiple_choice",
}

export const TYPE_OF_ATTRIBUTES_OPTIONS = [
  { value: TYPE_OF_ATTRIBUTE.is_required, label: "Required" },
  { value: TYPE_OF_ATTRIBUTE.is_multiple_choice, label: "Multiple-choice" },
];

export enum TYPE_OF_PRODUCTS {
  FOOD = "food",
  RETAIL = "retail",
}

export const TYPE_OF_PRODUCT_OPTIONS = [
  { value: TYPE_OF_PRODUCTS.FOOD, label: "Food" },
  { value: TYPE_OF_PRODUCTS.RETAIL, label: "Retail" },
];

export const PRODUCT_VARIANTS = "__pv";

export const DISCOUNT_PERCENTAGE_OPTIONS = [
  { value: 10, label: "10%" },
  { value: 20, label: "20%" },
  { value: 30, label: "30%" },
  { value: 40, label: "40%" },
  { value: 50, label: "50%" },
  { value: 60, label: "60%" },
  { value: 70, label: "70%" },
  { value: 80, label: "80%" },
  { value: 90, label: "90%" },
  { value: 100, label: "100%" },
];
